
import "/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/components/NoticeIcon/index.less?modules";
export default {"badge": `badge-roWbiqTm`,"tabs": `tabs-mG2IdEAu`,"icon": `icon-g9vOSi-7`,"popover": `popover-FLZVU-gN`,"noticeButton": `noticeButton-kcgBoEWz`}
